import { PaymentTermsGroup } from '../constants/payment-terms-group.js';
// WHY: single source for this label map -- it was previously hand-copied in apps/api's history-diff labeling and apps/web's price-sheet/pricing-rules UI, and could drift between them.
export const PAYMENT_TERMS_GROUP_LABELS = {
    [PaymentTermsGroup.NET]: 'Net',
};
//# sourceMappingURL=payment-terms-group-labels.js.map